import { Dispatch, createContext } from 'react'

import { BenefitModalAction } from './actions'
import { BenefitModalState } from './state'

interface BenefitModalContextType {
  state: BenefitModalState
  dispatch: Dispatch<BenefitModalAction>
}

export const BenefitModalContext = createContext<BenefitModalContextType>({
  state: {
    openModal: null,
  },
  dispatch: () => {},
})
